import type { TGetSimulacoesPorIdsResponse } from '@/features/simulacao/interfaces/simulacao.type'
import { HttpService } from '@/shared/lib/http'

export class GetSimulacoesPorIds extends HttpService {
  execute = async (ids: string[]) => {
    return this.http.get<TGetSimulacoesPorIdsResponse>(`/api/v2/Simulacao/lista`, {
      params: { ids },
      paramsSerializer: { indexes: null },
    })
  }
}
